<template lang="pug">
Tabs.ticket-hub
    template(slot="tabbar-buttons")
        //- Convention, left to right: the destructive action, the way out, the
        //- primary action last - the same order the ticket detail's tab bar
        //- carries (spam, delete, dismiss, save-and-close, save).
        el-button.delete-button(
            v-if="saveState.id && !saveState.loadError && canDeleteTickets"
            circle
            type="danger"
            icon="el-icon-fa-trash-alt far"
            :title="$t('Delete project')"
            :loading="saveState.deleting"
            @click="callDetail('confirmDelete')"
        )
        el-button(
            v-if="!saveState.loadError"
            circle
            icon="el-icon-fa-times fas"
            @click="callDetail('dismiss')"
        )
        el-button(
            v-if="!saveState.loadError && canUpdateTickets"
            circle
            type="primary"
            icon="el-icon-fa-pen fas"
            @click="callDetail('edit')"
        )
    el-card(shadow="always")
        project-detail(ref="detail" scope="cms" @state="saveState = $event")
    .buttons-flex(v-if="!saveState.loadError")
        .form-buttons
        .form-buttons
            el-button(round icon="el-icon-fa-times fas" @click="callDetail('dismiss')") {{ $t('Dismiss') }}
            el-button(v-if="canUpdateTickets" round type="primary" icon="el-icon-fa-pen fas" @click="callDetail('edit')") {{ $t('Edit') }}
</template>

<i18n>
{
    "de": {
        "Dismiss": "Verwerfen",
        "Delete project": "Projekt löschen",
        "Edit": "Bearbeiten"
    }
}
</i18n>

<script>
import Tabs from '@/extensions/communication/views/Partials/Tabs';
import ProjectDetail from '@/extensions/tickets/views/Projects/ProjectDetail';
import { checkRestrictions } from '@/helpers';

export default {
    name: 'CmsProjectDetail',
    components: { Tabs, 'project-detail': ProjectDetail },
    data() {
        return {
            saveState: {},
        };
    },
    computed: {
        // Projects share the ticket right: editing one is its update flag,
        // deleting one its delete flag.
        canUpdateTickets() {
            return checkRestrictions(['ex:tckt:tickets'], 'update');
        },
        canDeleteTickets() {
            return checkRestrictions(['ex:tckt:tickets'], 'delete');
        },
    },
    methods: {
        callDetail(method, ...args) {
            const detail = this.$refs.detail;
            if (detail) detail[method](...args);
        },
    },
};
</script>
